<template>
  <div v-show="!isReady">
    <div>
      <div>
        <div class="flex-column flex-lg-row">
          <div class="flex-lg-row-fluid mb-10 mb-lg-0">
            <div class="card">
              <div class="card-header flex-wrap border-0 pt-6 pb-0">
                <div class="card-title">
                  <router-link :to="{ name: 'store-details-entries', params: { id: $route.params.id } }" class="btn btn-sm btn-light me-4">
                    <i class="bi bi-arrow-left me-1"></i>{{ $t('back') }}
                  </router-link>
                  <div class="d-flex align-items-center flex-equal fw-row me-4 order-2" data-bs-toggle="tooltip"
                        data-bs-trigger="hover" title="Date d'établissement">
                    <div class="fs-6 fw-bolder text-gray-800 text-nowrap">{{ $t('store.entrie.create.date') }}</div>
                    <div class="position-relative d-flex align-items-center w-250px">
                      <input required class="form-control form-control-transparent fw-bolder pe-5 kt_voucher_date"
                              v-model="formContentEntrie.date" :placeholder="$t('store.entrie.create.date_placeholder')"
                              name="invoice_date" />
                      <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                fill="currentColor" />
                          </svg>
                        </span>
                    </div>
                  </div>
                </div>
                <div class="card-toolbar">
                  <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4"
                        data-bs-toggle="tooltip" data-bs-trigger="hover" title="Enter invoice number">
                    <span class="fs-6 fw-bolder text-gray-800">{{ $t('store.entrie.titre') }} : </span>
                    <input type="text" readonly class="form-control form-control-transparent fw-bolder fs-3 w-250px"
                            :value="numberEnt" />
                  </div>
                  <div class="d-flex align-items-center justify-content-end flex-equal order-3 fw-row"
                        data-bs-toggle="tooltip" data-bs-trigger="hover" title="Specify invoice due date">
                    <div class="fs-6 fw-bolder text-gray-800 text-nowrap">{{ $t('store.name') }} :</div>
                    <div class="position-relative d-flex align-items-center w-150px">
                      <input class="form-control form-control-transparent fw-bolder pe-5" :value="store.name" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="separator separator-dashed"></div>
              <!-- Entrée par catégorie : ajoute tous les articles des catégories choisies -->
              <div v-if="byCategory" class="px-12 pt-8">
                <label class="form-label required">{{ $t('product.category') }}</label>
                <div class="d-flex gap-3 align-items-start">
                  <div class="flex-grow-1">
                    <select class="form-select kt_select2" name="entry_categories" multiple data-control="select2"
                            :data-placeholder="$t('store.entrie.add_by_cat')">
                      <template v-for="category in getCategories" :key="category.id">
                        <optgroup v-if="category.childrens && category.childrens.length" :label="category.name">
                          <option :value="category.id">{{ category.name }}</option>
                          <option v-for="sub in category.childrens" :key="sub.id" :value="sub.id">{{ sub.name }}</option>
                        </optgroup>
                        <option v-else :value="category.id">{{ category.name }}</option>
                      </template>
                    </select>
                  </div>
                  <button type="button" class="btn btn-sm btn-light-primary text-nowrap" :disabled="!selectedCategories.length" @click="addCategoryProducts">
                    <i class="bi bi-plus-lg me-1"></i>{{ $t('product.add_product') }}
                  </button>
                </div>
              </div>
              <div class="card-body p-12">
                <div class="mb-0">
                  <div class="card">
                    <div class="card-body mt-4 rounded bg-light" v-for="(content, index) in formContentEntrie.items" :key="index">
                      <div class="row">
                        <div class="col-md-5 col-sm-12 mb-3">
                          <label class="form-label required">{{ $t('product.name') }}</label>
                          <select :id="'remove_enty_product' + index" :data-product-key="index" class="form-select kt_select2 mb-3" data-control="select2" required
                                  v-model="content.id" name="product_sale_element_entry_create"
                                  :data-placeholder="$t('store.select_product_placeholder')" data-allow-clear="false">
                            <optgroup v-for="group in groupProducts(filterProductSaleElements(index))" :key="group.category_id" :label="group.category_name">
                              <option v-for="product in group.products" :key="product.id" :value="product.id">{{ product.declination_title }}</option>
                            </optgroup>
                          </select>

                        </div>
                        <div class="col-md-3 col-sm-12 mb-2">
                          <label class=" form-label">{{ $t('product.lot') }}</label>
                          <select :id="'remove_entry_lot' + index" :data-product-key="index"
                                  class="form-select kt_select2 " data-control="select2" name="lot" v-model="content.product_lot_id"
                                  :data-placeholder="$t('product.select_lot')"
                                  data-allow-clear="false">
                            <option v-for="lot in filterProductSaleElementLots(index, content.id)" :key="lot.id" :value="lot.id">
                              {{ lot.lot.name }} ({{ lot.lot.item_number }})
                            </option>
                          </select>
                        </div>

                        <div class="col-md-2 col-sm-12 mb-3">
                          <label class="form-label required"> {{ $t('product.stock') }}</label>
                          <input type="number" :id="'stock_initial_'+index" :name="'stock_initial_'+index" @input="formatNumber" class="form-control" min="0" v-model="content.quantity"
                                 required />
                        </div>
                        <div class="col-md-1 col-sm-12 mt-5">
                          <button :data-key="index" @click.prevent="dropStoreLine(index)" type="button"
                                  class="btn btn-sm btn-light-danger" data-kt-element="remove-item">
                              <span class="svg-icon svg-icon-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                  <path
                                      d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                      fill="currentColor" />
                                  <path opacity="0.5"
                                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                        fill="currentColor" />
                                  <path opacity="0.5"
                                        d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                        fill="currentColor" />
                                </svg>
                              </span>
                            {{ $t('product.delete') }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <div class="form-group mt-5">
                        <button @click.prevent="addLigne" type="button" class="btn btn-sm btn-light-primary">
                            <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                   fill="none">
                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1"
                                      transform="rotate(-90 11 18)" fill="currentColor" />
                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                              </svg>
                            </span>
                          {{ $t('product.add_product') }}
                        </button>
                      </div>

                      <div class="mt-5 d-flex justify-content-end">
                        <button @click="createEntrie" class="btn btn-sm btn-primary" id="kt_invoice_submit_button"
                                :disabled="isLoading">
                          <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                          <span class="" v-else>{{ $t('loading') }}
                              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Wrapper-->

                <!--end::Form-->
              </div>
              <!--end::Card body-->

            <!--end::Card-->


          <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--end::Content-->
          <!--begin::Sidebar-->

          <!--end::Sidebar currencie-->
        </div>
        <!--end::Layout-->
      </div>
      <!--end::Container-->
    </div>
  </div>
  <div class="text-center py-10" v-show="isReady">
    <Loader />
  </div>
</template>


<script>
import Select from "@/components/General/Select.vue";
import Loader from "@/components/Loader.vue";
import { mapActions, mapGetters } from 'vuex'
import { groupProductsByCategory } from '@/composables/productCategoryGroups'

export default {

  components: {
    Select,
    Loader
  },

  data() {
    let date = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    let formattedDate = `${(date < 10) ? '0' + date : date}/${(month < 10) ? '0' + month : month}/${year}`;
    return {
      isLoading: false,
      store: {},
      numberEnt: '',
      title: 'New Entries',
      breadcrumbs: [
        {
          name: i18n.global.t('breadcrumbs.store.dashboard'),
          path: '/admin/dashboard'
        },
        {
          name: i18n.global.t('breadcrumbs.store.path'),
          path: '/admin/stores'
        },
        {
          name: i18n.global.t('breadcrumbs.store.entrie.path'),
          path: '/admin/stores/' + this.$route.params.id + '/views/entries'
        },
        {
          name: i18n.global.t('breadcrumbs.store.entrie.pathEntrie'),
          path: '/admin/store/' + this.$route.params.id + '/create/entrie'
        }
      ],
      formContentEntrie: {
        store_id: this.$route.params.id,
        numero: '',
        date: formattedDate,
        items: [
          {
            product_sale_element_id: null,
            quantity: null,
            product_lot_id: null
          }
        ]
      },
      productLot: [],
      porductSaleElementLots: [],
      selectedCategories: [],
      isReady: false

    }
  },

  watch: {
    'formContentEntrie.items.length': function () {
      this.$nextTick(() => {
        this.initSelect2()
        $(".kt_voucher_date").flatpickr({
          dateFormat: "d/m/Y",
        })
      })
    },
  },

  async mounted() {
    this.isReady = true
    this.loadCategories()

    this.loadAllProductSale()
    this.loadAllProductSale()
    this.initProductSaleElementLots()

    let response = await this.showStore(this.$route.params.id)
    this.store = response.data.store
    let prefixe = this.store.prefixe ?  this.$addYearToPrefixe(this.store.prefixe)  : 'ENT/' + this.store.name.slice(0, 3).toUpperCase() + '/' + (new Date()).getFullYear()
    this.numberEnt = prefixe + '/' + this.$incrementValue(response.data.entryNumber)

    $(".kt_voucher_date").flatpickr({
      dateFormat: "d/m/Y",
    })
    this.initSelect2()

    this.isReady = false
  },
  computed: {
    ...mapGetters('products', ['getProductSaleElements']),
    ...mapGetters('categories', ['getCategories']),

    byCategory() {
      return this.$route.query.mode === 'category'
    },

    productSaleElements() {
      if (this.formEntryContent.products && this.formContentEntrie.items.length && this.formContentEntrie.items[0].id !== null) {
        return this.getProductSaleElements.filter(product => !this.formContentEntrie.items.some(p => p.id === product.id))
      }
      return this.getProductSaleElements
    }

  },
  methods: {
    ...mapActions('products', ['loadAllProductSale','getProductSaleElementLot', 'listProductLots']),
    ...mapActions('store', ['createEntrieStore', 'showStore', 'numberEntryOutput']),
    ...mapActions('categories', ['loadCategories']),

    groupProducts(products) {
      return groupProductsByCategory(products, this.getCategories)
    },

    // Ajoute une ligne par article des catégories choisies (sans doublon)
    addCategoryProducts() {
      const already = this.formContentEntrie.items.map(item => item.id).filter(Boolean)
      const products = this.getProductSaleElements.filter(product =>
        this.selectedCategories.includes(product.product_category_id) && !already.includes(product.id))
      if (!products.length) {
        window.toastr['info'](i18n.global.t('store.entrie.no_product_in_category'))
        return
      }
      const filled = this.formContentEntrie.items.filter(item => item.id)
      this.formContentEntrie.items = [
        ...filled,
        ...products.map(product => ({id: product.id, quantity: null, product_lot_id: null})),
      ]
    },

    filterProductSaleElements(key) {
      let productBeforeKey = [];

      for (let i = 0; i < key; i++) {
        const product = this.formContentEntrie.items[i];
        if (this.filterProductSaleElementLots(i, product.id).length === 0) {
          productBeforeKey.push(product.id);
        }
      }
      return this.getProductSaleElements.filter(product => !productBeforeKey.includes(product.id));

      // let product_lists = this.getProductSaleElements.filter(product => !productBeforeKey.includes(product.id));
      // return this.sortByKey(product_lists, "name");
    },

    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key].toLowerCase();
        var y = b[key].toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    async initProductSaleElementLots(){
      let response = await this.listProductLots()
      this.porductSaleElementLots = response.data
    },


    filterProductSaleElementLots(key, product_sale_element_id) {
      if(product_sale_element_id != null){
        let newProductLots = this.porductSaleElementLots.filter(lot => lot.product_sale_element_id === product_sale_element_id);
        let productBeforeKey = this.formContentEntrie.items
            .filter((data, i) => i < key)
            .map(data => data.product_lot_id);

        return newProductLots.filter(lot => !productBeforeKey.includes(lot.id));
      }
      return []
    },


    addLigne() {
      this.formContentEntrie.items.push({
        product_sale_element_id: null,
        quantity: null,
        product_lot_id: null
      })

      this.$nextTick(() => {
        this.initSelect2()
      });

    },

    dropStoreLine(key) {
      if (this.formContentEntrie.items.length >= 2) {
        this.formContentEntrie.items.splice(key, 1)
      }
    },

    formatProduct(items) {
      return (items?.attribut?.length > 0) ? ' (' + items?.attribut + ')' : '';
    },


    async createEntrie() {
      Swal.fire({
        title: i18n.global.t('notification.irreversible_action'),
        text: i18n.global.t('store.confirm_entry_title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.yes'),
        cancelButtonText: i18n.global.t('store.no'),
      }).then(async (result) => {
        if (result.value) {
          try {
            this.submitCreateEntrie()
          } catch (e) {
            console.log(e)
          }
        }
      });
    },

    async submitCreateEntrie() {
      let response = {}
      this.isLoading = true
      try {
        this.formContentEntrie.numero = this.numberEnt
        response = await this.createEntrieStore(this.formContentEntrie)
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'))
        this.isLoading = false
        this.$router.push({ name: 'store-details-entries', params: { id: this.$route.params.id } })
      } catch (e) {
        this.isLoading = false
      }
    },

    initSelect2() {
      let kt_select2 = $(".kt_select2")
      kt_select2.select2()
      kt_select2.select2().select2()

      kt_select2.change((e) => {
        switch (e.target.name) {
          case 'product_sale_element_entry_create':
            this.formContentEntrie.items[e.target.getAttribute('data-product-key')].id = e.target.value;
            this.formContentEntrie.items[e.target.getAttribute('data-product-key')].product_lot_id = null

            break;
          case 'lot':
            this.formContentEntrie.items[e.target.getAttribute('data-product-key')].product_lot_id = e.target.value;
            break;
          case 'entry_categories':
            this.selectedCategories = $(e.target).val() || [];
            break;
          default:
            break;
        }
      });

    }
  }
}
</script>

<style scoped>
.badge {
  display: none !important;
  align-items: center;
}

.badge-light-danger {
  color: #f1416c;
  background-color: #fff5f8;
  padding: 15px !important;
  text-align: center !important;
}
</style>